import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    const leavesArray = Array.from({ length: 7 }).map(() => ({
      left: Math.random() * 100 + 'vw',
      delay: Math.random() * 5 + 's',
      duration: 5 + Math.random() * 5 + 's',
      rotate: Math.random() * 60 - 30 + 'deg'
    }));
    setLeaves(leavesArray);
  }, []);

  return (
    <div className="loading-screen">
      {/* {leaves.map((leaf, idx) => (
        <img
          key={idx}
          src="/pine.png"
          alt="leaf"
          className="leaf"
          style={{
            left: leaf.left,
            animationDelay: leaf.delay,
            animationDuration: leaf.duration,
            transform: `rotate(${leaf.rotate})`
          }}
        />
      ))} */}
      <img src="/amthill.png" alt="Ampthill Logo" className="loading-logo" />
    </div>
  );
};

export default LoadingScreen;
